import React from 'react';

import PropTypes from 'prop-types';

import {
    localize,
} from 'wanderu-i18n';
import {
    durationToHoursAndMinutes,
} from 'wanderu-utils';

import styles from './Duration.scss';

function Duration(props) {
    const {
        className = '',
        duration,
        i18nMoment,
        t,
    } = props;

    const tripDuration = i18nMoment.duration(duration);

    const tripDurationString = tripDuration.days() > 0
        ? 'trip-duration_days'
        : 'trip-duration_hours';

    return (
        <span
            aria-label={t('baseApp:duration')}
            aria-live="polite"
            className={`${styles.duration} ${className}`}
        >
            {t(`baseApp:${tripDurationString}`, durationToHoursAndMinutes(tripDuration))}
        </span>
    );
}

Duration.propTypes = {
    className: PropTypes.string,
    duration: PropTypes.number.isRequired,
    i18nMoment: PropTypes.func,
    t: PropTypes.func,
};

export {
    Duration,
};
export default localize(Duration);
